import styled from '@emotion/styled';

import { Select } from 'uiToolkitV1/Select';

const StyledSelect = styled(Select)`
  .select__menu {
    right: 0;
  }
`;

export default StyledSelect;
